import React from 'react';
import Marquee from 'react-fast-marquee';

import './RecognitionBar.css';
import { recognitionData } from '../../data/recognitionData';

function RecognitionBar() {
    return (
        <section className="recognition-bar" aria-label="Recognition and affiliations">
            <div className="recognition-bar--label">
                <span>Recognized · Acquired · Certified · Featured</span>
            </div>
            <div className="recognition-bar--track">
                <Marquee gradient={false} speed={32} pauseOnHover>
                    {recognitionData.map((item, index) => (
                        <span className="recognition-bar--item" key={index}>
                            {item.logo && (
                                <img className="recognition-bar--logo" src={item.logo} alt="" aria-hidden="true" />
                            )}
                            {item.label}
                            <span className="recognition-bar--dot" aria-hidden="true">·</span>
                        </span>
                    ))}
                </Marquee>
            </div>
        </section>
    );
}

export default RecognitionBar;
